import * as React from 'react';
import { IconPropsType } from 'designSystem/types/icons';

interface ISaveIconProps extends IconPropsType {}

const SaveIcon = ({
  size = 10,
  stroke = '#545454',
  ...props
}: ISaveIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 5.05556H9H1H0.5V0.555556C0.5 0.540821 0.505853 0.52669 0.516272 0.516272C0.52669 0.505853 0.540821 0.5 0.555556 0.5H7.57067L9.5 2.42933V5.05556ZM7.5 9.5H2.5V7.16667H7.5V9.5Z"
      stroke={stroke}
    />
  </svg>
);

export default SaveIcon;
